import MuiAlert, { AlertProps } from '@mui/material/Alert'
import Snackbar from '@mui/material/Snackbar'
import Stack from '@mui/material/Stack'
import * as React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { notificationSuccess } from '../../store/actions'
// import { notificationSuccess } from '../../store/actions'

const Alert = React.forwardRef<HTMLDivElement, AlertProps>(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />
})

export default function SnackbarOrigin() {
  const dispatch: any = useDispatch()
  const { notificationMsg, severity } = useSelector((state: any) => state.customization)

  const handleClose = (event?: React.SyntheticEvent | Event, reason?: string) => {
    if (reason === 'clickaway') {
      return
    }
    dispatch(notificationSuccess(''))
  }

  return (
    <Stack spacing={2} sx={{ maxWidth: 600 }}>
      <Snackbar
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
        open={notificationMsg !== '' ? true : false}
        autoHideDuration={2500}
        onClose={handleClose}
      >
        <Alert onClose={handleClose} id='alert' severity={severity} sx={{ width: '100%', color: '#fff' }}>
          {notificationMsg}
        </Alert>
      </Snackbar>
    </Stack>
  )
}
